module.exports = __webpack_public_path__ + "img/bg_main_t_r_3.a6a22524.png";